import _ from 'underscore';

export const MinFluctuationsCountToShowAllInsightsButton = 8;

export const FluctuationGranularity = {
  Day: 'Day',
};

export const FluctuationDateFormat = 'MM-dd-yyyy';

// Microsoft.Advertiser.AdInsight.Fluctuation.Schema
export const FluctuationType = {
  1: 'Impression',
  2: 'Click',
  3: 'Spend',
  4: 'Conversion',
};

export const FluctuationTypeKey = _.chain(FluctuationType)
  .invert()
  .mapObject(value => parseInt(value, 10))
  .value();

export const MaxFluctuationsPaginationCount = 7;
